import React, { useState } from 'react';
import { Btn, H2, P } from '../../../../../AbstractElements';
import { Link } from 'react-router-dom';
import { LoginFormProp } from '../../../../../Types/Others.type';
import CommonLogo from './CommonLogo';
import { Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { EmailAddress, Password, RememberPassword, SignIn, SignInAccount } from '../../../../../Utils/Constants';
import SocialLinks from './SocialLinks';

export default function LoginForm({ logoClass }: LoginFormProp) {
    const [isPasswordVisible, setPasswordVisible] = useState(false);
    // const toggle = () => setPasswordVisible(!isPasswordVisible);
    const [formData, setFormData] = useState({ email: '', password: '', checkbox1: false });

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value, type, checked } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [id]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setFormData({ email: '', password: '', checkbox1: false });
    };

    return (
        <Container className="d-flex align-items-center justify-content-center min-vh-100">
            <Row className="w-100 justify-content-center">
                <Col xs={12} sm={10} md={6} lg={4}>
                    <div className="text-center mb-4">
                        <CommonLogo logoClass={logoClass} />
                    </div>
                    <div className="login-main p-4 shadow rounded">
                        <Form className="theme-form" onSubmit={handleSubmit}>
                            <H2 className="text-center">{SignInAccount}</H2>
                            <P className="text-center">{"Enter your email & password to login"}</P>

                            <FormGroup>
                                <Label>{EmailAddress}</Label>
                                <Input type="email" required placeholder="Test@gmail.com" id="email" value={formData.email} onChange={handleInputChange} />
                            </FormGroup>

                            <FormGroup>
                                <Label>{Password}</Label>
                                <div className="form-input position-relative">
                                    <Input type={isPasswordVisible ? 'text' : 'password'} required placeholder="*********" id="password" value={formData.password} onChange={handleInputChange} />
                                    {/* <div className="show-hide" onClick={toggle}>
                                        <span className={!isPasswordVisible ? 'show' : ''}></span>
                                    </div> */}
                                </div>
                            </FormGroup>

                            <Row className="align-items-center mb-3">
                                <Col xs={7}>
                                    <FormGroup className="checkbox-solid-info" check>
                                        <Input id="solid6" type="checkbox" checked={formData.checkbox1} onChange={handleInputChange} />
                                        <Label htmlFor="solid6" check>{RememberPassword}</Label>
                                    </FormGroup>
                                </Col>
                                <Col xs={5} className="text-end">
                                    <Link to={`${process.env.PUBLIC_URL}/authentication/forget_password`}>{'Forgot password?'}</Link>
                                </Col>
                            </Row>

                            <Btn color='primary' className="w-100">{SignIn}</Btn>

                            <div className="mt-3">
                                <SocialLinks />
                            </div>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}
